import { jsx as t } from "react/jsx-runtime";
import { ExternalLink as n } from "../ExternalLink/ExternalLink.js";
const p = "qodana-support@jetbrains.com", m = ({ label: o, email: r = p }) => /* @__PURE__ */ t(n, { href: `mailto:${r}`, children: o ?? r });
export {
  p as QODANA_SUPPORT_EMAIL,
  m as SupportLink
};
